<template>
	<div v-parallax-fit="parallax" class="slide-polaroid">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/03_family04.png">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 1600,
						end: 2000,
						fromStyle: { transform: 'translateX(0%) translateY(0%) scale(0) rotate(0deg)' },
           				toStyle: { transform: 'translateX(0%) translateY(0%) scale(1) rotate(0deg)' },
						easing: 'linear'
					},
					{
						start: 3600,
						end: 4200,
						fromStyle: { transform: 'translateX(0%) translateY(0%) scale(1) rotate(0deg)' },
           				toStyle: { transform: 'translateX(-120%)  translateY(0%) scale(1) rotate(30deg)' },
						easing: 'linear'
					},
					{
						start: 4200,
						end: 5200,
						fromStyle: { transform: 'translateX(-120%)  translateY(0%) scale(1) rotate(30deg)' },
           				toStyle: { transform: 'translateX(-1000%)  translateY(0%) scale(1) rotate(30deg)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.slide-polaroid {
		max-width: 120px;
		position: absolute;
		left: 17%;
		top: -9%;
		z-index: 2;
		transition: all 0.1s linear;
	}

	@media screen and (max-width: 1680px) {
		.slide-polaroid {
			max-width: 100px;
			top: -4%;
		}
	}

	@media screen and (max-width: 1280px) {
		.slide-polaroid {max-width: 60px;}
	}

	@media screen and (max-width: 650px) {
		.slide-polaroid {max-width: 30px;}
	}
</style>
